import {
  Component,
  OnInit,
  AfterViewInit,
  AfterViewChecked,
  ViewChild
} from "@angular/core";
import { ApiService } from "../../services/api.service";
import { SharedService } from "../../services/shared.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

import {
  customLabels,
  customBankLabels,
  getRiskColor
} from "../../shared/constants";

@Component({
  selector: "app-portfolio",
  templateUrl: "./portfolio.component.html",
  styleUrls: ["./portfolio.component.scss"]
})
export class PortfolioComponent implements OnInit {
  public companyId: string;
  public newsList: any;
  public isWatched = false;
  public getRiskColor = getRiskColor;
  public gaugeChart1 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Excellent"
  };
  public gaugeChart2 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Not Attractive",
    upperLimitDisplay: "Very Attractive"
  };
  public gaugeChart3 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Poor",
    upperLimitDisplay: "Outstanding"
  };
  public gaugeChart4 = {
    type: "AngularGauge",
    caption: "",
    value: 0,
    lowerLimitDisplay: "Sell",
    upperLimitDisplay: "Buy"
  };
  public shareHoldingChartPrev = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "PQ" }
  };
  public shareHoldingChartLast = {
    type: "pie2d",
    data: [],
    genConfig: { caption: "LQ" }
  };

  public userInfo: any;
  public showPlans = false;
  public visitCnt = 0;
  public portfolioData: any;
  public basicData: object;
  public otherData: object;
  public keyFinancialQuarterly: object;
  public otherDataFields = [];
  public otherDataCols = [];
  public ttmData = [];
  public peerCompCols = [];
  public valuationMCols = [
    { title: "latest_", name: "Last FY" },
    { title: "avg_", name: "Average" },
    { title: "median_", name: "Median" }
  ];
  public valuationMFields = [];
  public keyFinancialFields = [];
  public keyFinancialCols = [];
  public peerCompFields = [
    {
      title: "companyname",
      name: "Company",
      type: "string",
      isLink: true,
      unit: ""
    },
    {
      title: "z1_rating",
      name: "Overall Rating",
      type: "star",
      isLink: false,
      unit: ""
    },
    {
      title: "business_rating",
      name: "Business Rating",
      type: "star",
      isLink: false,
      unit: ""
    },
    {
      title: "valuation_rating",
      name: "Valuation Rating",
      type: "star",
      isLink: false,
      unit: ""
    },
    {
      title: "p11_quarterly_trends_score_rating",
      name: "Quarterly Trend Rating",
      type: "star",
      isLink: false,
      unit: ""
    }
  ];
  public sensexVsPrice = {};
  public chartData: Object = { type: "pie2d" };
  public msLinechartData: Object = {
    type: "msline",
    config: {},
    genConfig: { caption: "Price Vs BSE 500", showLabels: 1, xAxisname: "" }
  };
  public salesChartData: Object = {
    type: "mscombidy2d",
    config: {},
    genConfig: {
      numberPrefix: "INR ",
      formatNumberScale: "0",
      rotateValues: "0",
      showValues: "1",
      placeValuesInside: "0"
    }
  };
  public profitChartData: Object = {
    type: "mscombidy2d",
    config: {},
    genConfig: {}
  };
  public ebitdaChartData: Object = {
    type: "mscombidy2d",
    config: {},
    genConfig: {
      caption: "EBITDA",
      xAxisname: "Years",
      drawAnchors: 1,
      anchorRadius: 3,
      showLabels: 1,
      pYAxisName: "EbitDA (RS. Crs)",
      sYAxisName: "EBITDA Margin %"
    }
  };

  public ttmCols:any = [
    { title: "Trailing Twelve Months Sales (Rs. Crs.)", field: "rlfysto" },
    /* { title: "Trailing 12 month OP", field: "rlfyop" },
    { title: "Trailing 12 month GP", field: "rlfygp" }, */
    { title: "Trailing 12 month NP (Rs. Crs.)", field: "rlfynp" },
    { title: "Trailing 12 month EPS (Rs.)", field: "rlfyeps" },
    { title: "Trailing Twelve Months PE (X)", field: "rlfype" }
  ];


  objectKeys = Object.keys;

  constructor(
    private _api: ApiService,
    public _shared: SharedService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _toast: ToastrService
  ) {
    this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.userInfo = this._shared.userInfo;
  }

  ngOnInit() {
    // console.log('id', this._route.snapshot.paramMap.get('id'), (this._route.snapshot.paramMap.get('id') === null));
    this.companyId =
      this._route.snapshot.paramMap.get("id") === null
        ? ""
        : this._route.snapshot.paramMap.get("id");
    this.getPortfolio();
    //this.getTTMCall();
  }

  checkNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  /* getRiskColor(value: any): string {
    const riskValue = String(value || "")
      .toLowerCase()
      .trim();

    switch (riskValue) {
      case "low":
        return "#00A550";

      case "low to moderate":
        return "#8DC63F";

      case "moderate":
        return "#dbd21d";

      case "moderately high":
        return "#F7941D";

      case "high":
        return "#F15A24";

      case "very high":
        return "#ED1C24";

      case "buy":
        return "#15bd7c";

      case "hold":
        return "#7f9d0c";

      case "satisfactory":
        return "#e34612";

      case "outstanding":
        return "#FFD700";

      case "excellent":
        return "#4CAF50";

      case "very attractive":
        return "#e31266";

      case "attractive":
        return "#BA55D3";

      case "moderately attractive":
        return "#BA55D3";

      case "not attractive":
        return "#607D8B";

      case "poor":
        return "#F44336";

      case "weak":
        return "#F44336";

      case "average":
        return "#F44336";

      case "sell":
        return "#F44336";

      case "unsatisfactory":
        return "#F44336";

      case "very good":
        return "#00BCD4";

      case "good":
        return "#24b37c";

      default:
        return "#000";
    }
  } */
  getTTMCall(){
     let params = {
        "co_code": this.companyId
        //"insert_date": "22-05-2026"
    };
     this._api.getStockTTM(params).subscribe(response => {
       console.log('TTM response >>>', response);
       this.ttmData = response.data;
     });
     /* this.ttmData = 
        [{
            "_id": "6a42d09bb786c5db3c55c9ed",
            "cn": "HDFC AMC",
            "sno": "21272",
            "sc_code": "541729",
            "yrc": "202603",
            "scr_dt": "29-Jun-2026",
            "noofmonths": "12",
            "var": "16",
            "eqc": "214.33",
            "fv": "5",
            "res": "9016.87",
            "div": "1080",
            "sto": "4617.26",
            "np": "2859.11",
            "cps": "68.4",
            "eps": "66.7",
            "vpcps": "0",
            "iyrc1": "202603",
            "vsto": "1061.67",
            "peps": "0",
            "pn": "50",
            "bv": "215.4",
            "latronw": "9231.09",
            "ape": "39.1",
            "apc": "38.1",
            "bval": "670.38",
            "nval": "42249.69",
            "mph": "2965",
            "mpl": "2206",
            "ncmpr": "2607",
            "cmpr": "2606",
            "mktcap": "111719.9",
            "nphy": "623.29",
            "npvhy": "-2",
            "inom1": "3",
            "rlfyyrc": "202603",
            "rlfysto": "3670.8",
            "rlfyop": "-0.33",
            "rlfyopm": "-0.01",
            "rlfygp": "3782.88",
            "rlfygpm": "81.93",
            "rlfynp": "2211.67",
            "rlfynpv": "16.18",
            "rlfyeps": "66.7",
            "rlfype": "39.07",
            "rlfycps": "0",
            "rlfypc": "0",
            "rlfydepn": "53.33",
            "lateqc": "214.33",
            "dlyprice": "2606",
            "gbl": "470.43",
            "totoloan": "0",
            "advan": "0",
            "nnpaasset": "0",
            "latopm": "82.2",
            "latgpm": "81.9",
            "lathyopm": "80.7",
            "pvbv": "12.0984215413185",
            "lname": "HDFC Asset Management Company Ltd",
            "co_code": "21272",
            "industry": "Finance"
        }]; */
  }
  getPortfolio() {
    let params = {};
    //console.log("company" + this.companyId + "----");
    if (this.companyId === "") {
      //console.log("1", this.companyId);
      params = "";
    } else {
      //console.log("2", this.companyId);
      params = {
        co_code: this.companyId,
        userid:
          this._shared.userInfo && this._shared.userInfo.identity.id
            ? this._shared.userInfo.identity.id
            : ""
      };
    }
    this._api.getCompanyPortfolio(params).subscribe(response => {
      this.visitCnt = response.company_count;
      this.portfolioData = response;

      this.getTTMCall();

      if (this.portfolioData.valuation_matrices.median_ev_per_ebidta) {
        this.portfolioData.valuation_matrices.median_ev_per_ebitda = this.portfolioData.valuation_matrices.median_ev_per_ebidta;
        delete this.portfolioData.valuation_matrices.median_ev_per_ebidta;
      }

      this.newsList = response.news ? response.news : {};
      //console.log("NEWS >>>", this.newsList);
      //console.log("2 getPortfolio###=>", this.portfolioData);
      if (response.message === "success") {
        console.log('INDUSTRIES: ', this.portfolioData.basic_data.industryname);
        this.portfolioData = response;
        let labels = customLabels;
        // if (this.portfolioData &&
        //   (this.portfolioData.basic_data.sectorcode === '00000006'
        //     || this.portfolioData.basic_data.sectorcode === '00000026')) {
        if (
          this.portfolioData.basic_data.industryname &&
          (this.portfolioData.basic_data.industryname.search("Bank") !== -1 ||
          this.portfolioData.basic_data.industryname.search("Miscellaneous") !== -1 ||
            this.portfolioData.basic_data.industryname.search("Finance")) !== -1
        ) {
          //console.log("Its Bank or Finance");
          labels = customBankLabels;
        } else {
          this.valuationMFields.unshift(
            {
              title: "ev_per_ebitda",
              name: labels.ev_per_ebitda.value,
              unit: labels.ev_per_ebitda.unit
            },
            {
              title: "p_per_s",
              name: labels.p_per_s.value,
              unit: labels.p_per_s.unit
            }
          );
        }

        //console.log(labels);

        this.keyFinancialFields = [
          {
            title: "net_sales",
            name: labels.net_sales.value + " " + labels.net_sales.unit,
            unit: ""
          },
          {
            title: "profit",
            name: labels.profit.value + " " + labels.profit.unit,
            unit: ""
          },
          {
            title: "eps",
            name: labels.eps.value + " " + labels.eps.unit,
            unit: ""
          }
        ];
        this.peerCompFields = [
          {
            title: "companyname",
            name: "Company",
            type: "string",
            isLink: true,
            unit: ""
          },
          {
            title: "z1_rating",
            name: "Overall Rating",
            type: "star",
            isLink: false,
            unit: ""
          },
          {
            title: "business_rating",
            name: "Business Rating",
            type: "star",
            isLink: false,
            unit: ""
          },
          {
            title: "valuation_rating",
            name: "Valuation Rating",
            type: "star",
            isLink: false,
            unit: ""
          },
          {
            title: "p11_quarterly_trends_score_rating",
            name: "Quarterly Trend Rating",
            type: "star",
            isLink: false,
            unit: ""
          }
        ];

        //console.log("@@@@@@@@labels", labels);

        this.valuationMFields.push(
          {
            title: "pe_ratio",
            name: labels.pe_ratio.value,
            unit: labels.pe_ratio.unit,
            median: "pe_ratio_median_value"
          },
          {
            title: "pb_ratio",
            name: labels.pb_ratio.value,
            unit: labels.pb_ratio.unit,
            median: "pb_ratio_median_value"
          },
          {
            title: "peg",
            name: labels.peg.value,
            unit: labels.peg.unit,
            median: ""
          },
          {
            title: "dividend_yield",
            name: labels.dividend_yield.value,
            unit: labels.dividend_yield.unit,
            median: ""
          },
          {
            title: "beta",
            name: labels.beta.value,
            unit: labels.beta.unit,
            median: ""
          },
          {
            title: "standard_deviation",
            name: labels.standard_deviation.value,
            unit: labels.standard_deviation.unit,
            median: ""
          }
        );
        this.salesChartData = {
          type: "mscombidy2d",
          config: {},
          genConfig: {
            caption: labels["sales"].value,
            xAxisname: "Years",
            drawAnchors: 1,
            anchorRadius: 3,
            showLabels: 1,
            pYAxisName: labels["sales"].value + " (RS. Crs)",
            sYAxisName: labels["sales_growth"].value + " %"
          }
        };
        this.profitChartData = {
          type: "mscombidy2d",
          config: {},
          genConfig: {
            caption: labels["net_profit"].value,
            xAxisname: "Years",
            drawAnchors: 1,
            anchorRadius: 3,
            showLabels: 1,
            pYAxisName: labels["net_profit"].value + " (RS. Crs)",
            sYAxisName: labels["profit_growth"].value + " %"
          }
        };
        this.basicData = this.portfolioData.basic_data;
        this.otherData = this.portfolioData.other_data;
        this.keyFinancialQuarterly = this.portfolioData.key_financial_quarterly;

        if (
          this.portfolioData.peer_comparison &&
          this.portfolioData.peer_comparison.length > 0
        ) {
          const peerComp = this.objectKeys(
            this.portfolioData.peer_comparison[0]
          );
          peerComp.forEach((val, key) => {
            if (
              val !== "last_year_price" &&
              val !== "yesterday_price" &&
              val !== "p11_quarterly_trends_score" &&
              val !== "p11_quarterly_trends_score_rating" &&
              val !== "valuation_rating" &&
              val !== "business_rating" &&
              val !== "z1_rating" &&
              val !== "p11_quarterly_trends_score_label" &&
              val !== "business_rating_label" &&
              val !== "z1_rating_label" &&
              val !== "valuation_rating_label"
            ) {
              /* console.log(
                "##### ====== ###### ",
                this.portfolioData.basic_data.industryname
              );
              console.log("####1", val); */

              if (
                this.portfolioData.basic_data.industryname.includes("Bank") ||
                this.portfolioData.basic_data.industryname.includes("NBFC") ||
                this.portfolioData.basic_data.industryname.includes("Finance")
              ) {
                /* if (
                  Valuation rating label
                  Z1 rating label
                  Business rating label
                  P11 quarterly trends score label

                  val !== "last_year_price" &&
                  val !== "yesterday_price" &&
                  val !== "p11_quarterly_trends_score" &&
                  val !== "p11_quarterly_trends_score_rating" &&
                  val !== "valuation_rating" &&
                  val !== "business_rating" &&
                  val !== "z1_rating"
                ) */

                this.peerCompCols.push({
                  title: val,
                  name: labels[val]
                    ? labels[val].value
                    : this._shared.getLabel(val),
                  unit: labels[val] ? labels[val].unit : "",
                  type: val === "companyname" ? "string" : "numeric",
                  isLink: val === "companyname" ? 1 : 0,
                  sort_order:
                    val === "companyname"
                      ? 1
                      : val === "marketCapitalization_latest"
                      ? 2
                      : val === "latest_sales"
                      ? 3
                      : val === "latest_sales_growth"
                      ? 4
                      : val === "latest_net_profit"
                      ? 5
                      : val === "latest_pe_ratio"
                      ? 6
                      : val === "latest_pb_ratio"
                      ? 7
                      : val === "latest_total_debt_per_net_worth"
                      ? 8
                      : val === "ev_per_ebitda_latest"
                      ? 9
                      : val === "capital_adequacy_ratio"
                      ? 10
                      : val === "percent_net_non_performing_assets"
                      ? 11
                      : val === "latest_roe"
                      ? 12
                      : 13
                });
                //console.log("********* IF **********", val);
              } else {
                if (
                  val !== "capital_adequacy_ratio" &&
                  val !== "percent_net_non_performing_assets"
                ) {
                  this.peerCompCols.push({
                    title: val,
                    name: labels[val]
                      ? labels[val].value
                      : this._shared.getLabel(val),
                    unit: labels[val] ? labels[val].unit : "",
                    type: val === "companyname" ? "string" : "numeric",
                    isLink: val === "companyname" ? 1 : 0,
                    sort_order:
                      val === "companyname"
                        ? 1
                        : val === "marketCapitalization_latest"
                        ? 2
                        : val === "latest_sales"
                        ? 3
                        : val === "latest_sales_growth"
                        ? 4
                        : val === "latest_net_profit"
                        ? 5
                        : val === "latest_pe_ratio"
                        ? 6
                        : val === "latest_pb_ratio"
                        ? 7
                        : val === "latest_total_debt_per_net_worth"
                        ? 8
                        : val === "ev_per_ebitda_latest"
                        ? 9
                        : val === "latest_roe"
                        ? 10
                        : 11
                  });
                  //console.log("********* ELSE **********", val);
                }
              }
            }
          });
          //console.log("####3");
          this.peerCompCols = this._shared.getFieldsSortedAsc(
            this.peerCompCols,
            "sort_order"
          );
        }
        if (this.portfolioData.other_data) {
          this.objectKeys(this.otherData).forEach((val, key) => {
            //console.log("#####1#####", val);
            this.otherDataFields.push({
              title: val,
              name: labels[val]
                ? labels[val].value
                : this._shared.getLabel(val),
              unit: labels[val] ? labels[val].unit : "",
              sort_order:
                val === "sales"
                  ? 1
                  : val === "sales_growth"
                  ? 2
                  : val === "net_profit"
                  ? 5
                  : val === "profit_growth"
                  ? 6
                  : val === "ebitDA"
                  ? 3
                  : val === "ebitDA_per_sales"
                  ? 4
                  : val === "eps_after_minority_interest_adj"
                  ? 7
                  : val === "eps_before_minority_adj"
                  ? 8
                  : val === "roe"
                  ? 9
                  : val === "total_debt_per_net_worth"
                  ? 10
                  : val === "assets"
                  ? 5
                  : 11
            });
          });

          const years = this.objectKeys(
            this.otherData[this.otherDataFields[0].title]
          );

          years.slice(5).forEach((val, key) => {
            this.otherDataCols.push({
              title: val,
              name: val
            });
          });

          const newOtherDataFields = [];
          this.otherDataFields.forEach((val, key) => {
            if (val.name === "ROE") {
              let newValObj = { ...val, name: "RoAE" };
              newOtherDataFields[key] = newValObj;
            } else {
              newOtherDataFields[key] = val;
            }
          });

          this.otherDataFields = newOtherDataFields;
          //console.log("#####2#####", this.otherDataFields);
          this.otherDataFields = this._shared.getFieldsSortedAsc(
            this.otherDataFields,
            "sort_order"
          );
        }
        if (this.keyFinancialQuarterly) {
          this.objectKeys(
            this.keyFinancialQuarterly[
              this.objectKeys(this.keyFinancialQuarterly)[0]
            ]
          ).forEach((val, key) => {
            this.keyFinancialCols.push({
              title: val,
              name: this.portfolioData.basic_data.is_quarterly_data_company
                ? this._shared.getQuarterString(val)
                : this._shared.getHalfYearlyString(val)
            });
          });
        }
        if (this.portfolioData.share_holding) {
          this.portfolioData.share_holding.forEach((val, key) => {
            if (key === 1) {
              const lastQ = this.objectKeys(val);
              lastQ.forEach((v, k) => {
                const color =
                  v === "FIIHolding"
                    ? "#6f42c1"
                    : v === "MutualFundHolding"
                    ? "#17a2b8"
                    : v === "PromoterHolding"
                    ? "#ffc107"
                    : v === "Promoter_PledgeSharesPercentage"
                    ? "#dc3545"
                    : v === "Others"
                    ? "#28a745"
                    : "#17a2b8";
                if (v !== "co_code" && v !== "yrc" && val[v] > 0) {
                  this.shareHoldingChartLast.data.push({
                    value: val[v],
                    label: labels[v].value,
                    isSliced: 0,
                    color: color
                  });
                }
              });
              this.shareHoldingChartLast.genConfig.caption = this._shared.getQuarterString(
                this.portfolioData.share_holding[1].yrc
              );
            }
            if (key === 0) {
              const prevQ = this.objectKeys(val);
              prevQ.forEach((v, k) => {
                const color =
                  v === "FIIHolding"
                    ? "#6f42c1"
                    : v === "MutualFundHolding"
                    ? "#17a2b8"
                    : v === "PromoterHolding"
                    ? "#ffc107"
                    : v === "Promoter_PledgeSharesPercentage"
                    ? "#dc3545"
                    : v === "Others"
                    ? "#28a745"
                    : "#17a2b8";
                if (v !== "co_code" && v !== "yrc" && val[v] > 0) {
                  this.shareHoldingChartPrev.data.push({
                    value: val[v],
                    label: labels[v].value,
                    isSliced: 0,
                    color: color
                  });
                }
              });
              this.shareHoldingChartPrev.genConfig.caption = this._shared.getQuarterString(
                this.portfolioData.share_holding[0].yrc
              );
            }
          });
        }
        if (this.portfolioData) {
          const dataSeries = [
            {
              seriesname: this.portfolioData.basic_data.co_name,
              data: [],
              color: "#6f42c1"
            },
            { seriesname: "BSE 500", data: [], color: "#17a2b8" },
            { seriesname: "Sensex", data: [], color: "#ffc107" } // NEW Sensex
          ];

          const dataLabels = [];
          this.portfolioData.sensex_vs_price.index.series.forEach(
            (val, key) => {
              // const dateLabel = new Date(val.my_date).getDate() + '-'
              //   + (new Date(val.my_date).getMonth() + 1) + '-'
              //   + new Date(val.my_date).getFullYear();
              // dataLabels.push({
              //   label: val.my_date
              // });
              let incDate = val.my_date.split("T")[0];
              incDate = incDate.split("-");
              val.my_date = incDate[2] + "-" + incDate[1] + "-" + incDate[0];
              dataLabels.push({ label: val.my_date });
              if (key === 0) {
                dataSeries[1].data.push({ value: 100 });
                dataSeries[0].data.push({ value: 100 });
                dataSeries[2].data.push({ value: 100 }); //Sensex
              } else {
                const d = (
                  (100 * val.value) /
                  this.portfolioData.sensex_vs_price.index.series[0].value
                ).toFixed(2);

                dataSeries[1].data.push({
                  value: d,
                  toolText: "BSE 500, " + ", " + val.my_date + ", " + d
                });

                const d1 = (
                  (100 *
                    this.portfolioData.sensex_vs_price.company_price[
                      this.portfolioData.basic_data.co_code
                    ][key][1]) /
                  this.portfolioData.sensex_vs_price.company_price[
                    this.portfolioData.basic_data.co_code
                  ][0][1]
                ).toFixed(2);

                dataSeries[0].data.push({
                  value: d1,
                  toolText:
                    this.portfolioData.basic_data.co_name +
                    val.my_date +
                    ", " +
                    d1
                });
                //------------
                try {
                  const sensexVal = this.portfolioData.sensex_vs_price.sensex
                    .series[key].value;
                  const baseSensex = this.portfolioData.sensex_vs_price.sensex
                    .series[0].value;
                  const d2 = ((100 * sensexVal) / baseSensex).toFixed(2);
                  dataSeries[2].data.push({
                    value: d2,
                    toolText: "Sensex, " + val.my_date + ", " + d2
                  });
                } catch (error) {
                  console.log("Error in Sensex", error);
                }
                //------------
              }
            }
          );

          //console.log("###dataLabels >>>", dataLabels);
          this.msLinechartData["config"] = {
            labels: dataLabels,
            dataSets: dataSeries,
            filterValues: this.portfolioData.filter_returns_value
          };
          this.msLinechartData["genConfig"] = {
            caption: "Price Vs BSE 500",
            subCaption:
              "Last Updated: " + dataLabels[dataLabels.length - 1].label,
            showLabels: 1,
            xAxisname: ""
          };
        }
        if (this.portfolioData.other_data) {
          const sYears = this.objectKeys(
            this.otherData[this.otherDataFields[0].title]
          );
          const salesSeries = [
            { seriesname: labels["sales"].value, data: [], color: "#Fadadd" },
            {
              seriesname: labels["sales_growth"].value,
              color: "#36A2EB",
              parentYAxis: "S",
              showValues: 0,
              renderAs: "spline",
              data: []
            }
          ];
          const profitSeries = [
            {
              seriesname: labels["net_profit"].value,
              data: [],
              color: "#Fadadd"
            },
            {
              seriesname: labels["profit_growth"].value,
              color: "#36A2EB",
              parentYAxis: "S",
              showValues: 0,
              renderAs: "spline",
              data: []
            }
          ];
          const ebitdaSeries = [
            { seriesname: labels["ebitDA"].value, data: [], color: "#Fadadd" },
            {
              seriesname: labels["ebitDA_per_sales"].value,
              color: "#36A2EB",
              parentYAxis: "S",
              showValues: 0,
              renderAs: "spline",
              data: []
            }
          ];
          const salesLabels = [];
          const profitLabels = [];
          const ebitdaLabels = [];

          //console.log('### sYears.slice(5) ', sYears.slice(5));
          sYears.slice(5).forEach((val, key) => {
            // // if (this.otherData['sales_growth'][val] !== '-' && this.otherData['sales'][val] !== '-') {
            salesLabels.push({ label: val });
            salesSeries[0].data.push({
              value:
                this.otherData["sales"][val] !== "-"
                  ? this.otherData["sales"][val].toFixed(2)
                  : ""
            });
            const sg =
              this.otherData["sales_growth"][val] !== "-"
                ? (this.otherData["sales_growth"][val] * 100).toFixed(2) + "%"
                : "";
            salesSeries[1].data.push({
              value: sg,
              toolText: "Sales Growth, " + val + ", " + sg
            });
            // }
            /* Profit Series */
            profitLabels.push({ label: val });
            profitSeries[0].data.push({
              value:
                this.otherData["net_profit"][val] !== "-"
                  ? this.otherData["net_profit"][val].toFixed(2)
                  : ""
            });
            const pg =
              this.otherData["profit_growth"][val] !== "-"
                ? (this.otherData["profit_growth"][val] * 100).toFixed(2) + "%"
                : "";
            profitSeries[1].data.push({
              value: pg,
              toolText: "Profit Growth, " + val + ", " + pg
            });
            /* Ebitda Series */
            /* console.log(
              "<<< industryname>> ",
              this.portfolioData.basic_data.industryname
            );
            console.log("## >", this.portfolioData.basic_data.industryname); */

            /* if (
              this.portfolioData.basic_data.industryname &&
              this.portfolioData.basic_data.industryname.includes("Bank") === true
                &&
                this.portfolioData.basic_data.industryname.includes("NBFC") === true
                &&
                this.portfolioData.basic_data.industryname.includes("Finance") === true
            ) { */
            //console.log("======= ## ========", this.portfolioData.basic_data.industryname, this.portfolioData.basic_data.industryname.search("Bank"));
            //NBFC-Holding Companies
            if (
              (this.portfolioData.basic_data.industryname &&
                this.portfolioData.basic_data.industryname.search("Bank") ===
                  -1 &&
                this.portfolioData.basic_data.industryname.includes("NBFC") ===
                  false &&
                this.portfolioData.basic_data.industryname.search("Finance") ===
                  -1) ||
              this.portfolioData.basic_data.industryname.search(
                "NBFC-"
              ) === 0
            ) {
              ebitdaLabels.push({ label: val });
              /* console.log("======= IF ========");
              console.log("## this.otherData >>", this.otherData);
              console.log(
                'this.otherData["ebitDA"][val] >>',
                this.otherData["ebitDA"][val]
              ); */

              ebitdaSeries[0].data.push({
                value:
                  this.otherData["ebitDA"][val] !== "-"
                    ? this.otherData["ebitDA"][val].toFixed(2)
                    : ""
              });

              const eg =
                this.otherData["ebitDA_per_sales"][val] !== "-"
                  ? (this.otherData["ebitDA_per_sales"][val] * 100).toFixed(2) +
                    "%"
                  : "";
              ebitdaSeries[1].data.push({
                value: eg,
                toolText: "Ebitda Margin, " + val + ", " + eg
              });
            }
            //console.log("============ > ",this.portfolioData.basic_data.industryname.search("NBFC-Asset"))
          });

          //console.log(this.salesChartData, this.profitChartData, ebitdaSeries);

          this.salesChartData["config"] = {
            labels: salesLabels,
            dataSets: salesSeries,
            filterValues: []
          };
          this.profitChartData["config"] = {
            labels: profitLabels,
            dataSets: profitSeries,
            filterValues: []
          };
          this.ebitdaChartData["config"] = {
            labels: ebitdaLabels,
            dataSets: ebitdaSeries,
            filterValues: []
          };
          console.log('## industryname', this.portfolioData.basic_data.industryname);
          console.log('## ebitdaLabels', ebitdaLabels);
          console.log('## ebitdaSeries', ebitdaSeries);

          //console.log(this.salesChartData, this.profitChartData, ebitdaSeries);
        }
        if (this.portfolioData.part_of_indices) {
          const indicesPart = this.objectKeys(
            this.portfolioData.part_of_indices
          );
          this.gaugeChart1.value = indicesPart[0]
            ? this.portfolioData.part_of_indices[indicesPart[0]].toFixed(2)
            : 0;
          this.gaugeChart2.value = indicesPart[2]
            ? this.portfolioData.part_of_indices[indicesPart[2]].toFixed(2)
            : 0;
          this.gaugeChart3.value = indicesPart[3]
            ? this.portfolioData.part_of_indices[indicesPart[3]].toFixed(2)
            : 0;
          this.gaugeChart4.value = indicesPart[1]
            ? this.portfolioData.part_of_indices[indicesPart[1]].toFixed(2)
            : 0;
          // this.gaugeChart4.caption = this.portfolioData.valuation_matrices.decision;
        }
        /* console.log(
          this.gaugeChart1,
          this.gaugeChart2,
          this.gaugeChart3,
          this.gaugeChart4
        ); */
      } else if (response.message === "exceeded") {
        console.log("show modal");
        // this._shared.toggleBenefits();
      }
    });
  }

  getPrint() {
    this._shared.printDoc("print-content", "stock-details");
  }

  getRatingStatement(str) {
    return str.substring(0, str.length - 1);
  }

  getRatingValue(value) {
    return value[value.length - 1] < 8 ? value[value.length - 1] : "";
    // return value.substring(-1);
  }

  gotoPlans() {
    //console.log("go to plan");
    // this.showPlans = true;
    this._shared.toggleBenefits();
    // const showPlans = this._shared.toggleBenefits();
  }

  addToWatchlist() {
    this._api
      .addStockToWatchlist({ co_code: this.companyId })
      .subscribe(response => {
        if (response.status === "success") {
          this._toast.success(response.message);
          this.isWatched = true;
        } else {
          this._toast.error(response.message);
        }
      });
  }
}
